<iframe *ngIf="frameUrl" class="office-document-viewer__frame" [src]="frameUrl" allowfullscreen></iframe>

<div *ngIf="editing" class="office-document-viewer__status">Opening editor...</div>
